var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.306,
    viewBox: "0 0 32 32.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call_Lists",
    "data-name": "Call Lists",
    transform: "translate(-9 -121.694)",
    opacity: 0.748
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    width: 32,
    height: 32,
    transform: "translate(9 122)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-th-list",
    "data-name": "Icon awesome-th-list",
    d: "M6.264,11.968v1.356A1.007,1.007,0,0,1,5.257,14.33H1.007A1.007,1.007,0,0,1,0,13.324V11.968a1.007,1.007,0,0,1,1.007-1.007H5.257a1.007,1.007,0,0,1,1.007,1.007ZM0,17.679v1.356a1.007,1.007,0,0,0,1.007,1.007H5.257a1.007,1.007,0,0,0,1.007-1.007V17.679a1.007,1.007,0,0,0-1.007-1.007H1.007A1.007,1.007,0,0,0,0,17.679Zm9.613,2.362H20.47a1.007,1.007,0,0,0,1.007-1.007V17.679a1.007,1.007,0,0,0-1.007-1.007H9.613a1.007,1.007,0,0,0-1.007,1.007v1.356A1.007,1.007,0,0,0,9.613,20.042Zm0-5.711H20.47a1.007,1.007,0,0,0,1.007-1.007V11.968a1.007,1.007,0,0,0-1.007-1.007H9.613a1.007,1.007,0,0,0-1.007,1.007v1.356A1.007,1.007,0,0,0,9.613,14.33Z",
    transform: "translate(14 127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-call",
    "data-name": "Icon feather-phone-call",
    d: "M18.669,14.629v2.338a1.559,1.559,0,0,1-1.7,1.559,15.425,15.425,0,0,1-6.726-2.393,15.2,15.2,0,0,1-4.677-4.677A15.425,15.425,0,0,1,3.174,4.7,1.559,1.559,0,0,1,4.725,3H7.064A1.559,1.559,0,0,1,8.622,4.341a10.008,10.008,0,0,0,.546,2.19,1.559,1.559,0,0,1-.351,1.645l-.99.99A12.471,12.471,0,0,0,12.5,13.842l.99-.99a1.559,1.559,0,0,1,1.645-.351,10.008,10.008,0,0,0,2.19.546A1.559,1.559,0,0,1,18.669,14.629Z",
    transform: "translate(40.306 132.559) rotate(135)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLists);
export default __webpack_public_path__ + "static/media/call-lists.71aaae2325a80565104cf00a813341ec.svg";
export { ForwardRef as ReactComponent };